import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

const ClearNotificationCatOnRouteChange = ({ children }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch({ type: 'events/clearNotificationCat' });
    }, [location, dispatch]);

    return children;
};

export default ClearNotificationCatOnRouteChange;
